import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ImageView = ({ imagePath, lightboxIsOpen, closeLightbox }) => (
    <Dialog open={lightboxIsOpen} onClose={closeLightbox} maxWidth="lg">
        <IconButton onClick={closeLightbox} aria-label="Close" sx={{ position: 'absolute', right: 8, top: 8, bgcolor: 'rgba(255,255,255,.8)' }}>
            <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0 }}>
            {imagePath && <img src={imagePath} alt="" style={{ display: 'block', maxWidth: '100%', maxHeight: '85vh' }} />}
        </DialogContent>
    </Dialog>
);

export default ImageView;
